/**
 * "none" is a select-only option. The API stores ungrouped references as null.
 */
export const toAccountingReferenceGroupSelectValue = (group: string | null | undefined): string => group ?? "none";

export const toAccountingReferenceGroupSaveValue = (group: string): string | null => (group === "none" ? null : group);
